import { MatchEventDto } from "../MatchEventDTO.js";

export default class GameFactEventDto extends MatchEventDto {
    constructor(event) {
      super(event);
      this.detail = {
        transformer: event.detail?.transformer,
        droper: event.detail?.droper,
        penaliter: event.detail?.penaliter,
        shoter: event.detail?.shoter,
        player: event.detail?.player,
        outplayer: event.detail?.outplayer,
        inplayer: event.detail?.inplayer,
  
        team: event.detail?.team ?? null,
        timer: event.detail?.timer ?? 0,
        period: event.detail?.period ?? 0,
  
        reason: event.detail?.reason,
        text: event.detail?.text,
        title: event.detail?.title,

        displayDate: event.detail?.displayDate ?? undefined,
      };

      this.isAutomaticCommentary = event.isAutomaticCommentary
      this.isEnableTrigger = event.isEnableTrigger
    }

    get period() {
      return this.detail.period;
    }
    set period(value) {
      this.detail.period = value;
    }
  
    get timer() {
      return this.detail.timer;
    }
    set timer(value) {
      this.detail.timer = value;
    }

    get displayDate() {
      return this.detail.displayDate;
    }
    set displayDate(value) {
      this.detail.displayDate = value;
    }
  
    get transformer() {
      return this.detail.transformer;
    }
    set transformer(value) {
      this.detail.transformer = value;
    }
  
    get droper() {
      return this.detail.droper;
    }
    set droper(value) {
      this.detail.droper = value;
    }
  
    get penaliter() {
      return this.detail.penaliter;
    }
    set penaliter(value) {
      this.detail.penaliter = value;
    }
  
    get player() {
      return this.detail.player;
    }
    set player(value) {
      this.detail.player = value;
    }
  
    
  
    get inplayer() {
      return this.detail.inplayer;
    }
    set inplayer(value) {
      this.detail.inplayer = value;
    }
  
    get outplayer() {
      return this.detail.outplayer;
    }
    set outplayer(value) {
      this.detail.outplayer = value;
    }
  
    get team() {
      return this.detail.team;
    }
    set team(value) {
      this.detail.team = value;
    }
  
    get reason() {
      return this.detail.reason;
    }
    set reason(value) {
      this.detail.reason = value;
    }
  
    get text() {
      return this.detail.text;
    }
    set text(value) {
      this.detail.text = value;
    }
  
    get title() {
      return this.detail.title;
    }
    set title(value) {
      this.detail.title = value;
    }
  
    
  
    initTimerPeriod(match){
      console.log('initTimerPeriod in parent GamefactEventDto')
      this.timer =  (match.timer === 0 && match.statusTimer ==="off") ? 0 : Math.floor(match.timer / 60) + 1;
      this.period = parseInt(match.period)
      console.log('timer, period : ', this.timer, this.period )
    }

    // 🔄 Met à jour dynamiquement une valeur dans `details`
    updateDetail(key, value) {

      console.log(`Updating detail key "${key}" with value:`, value)

      if(this.hasOwnProperty(key)){
        this[key] = value

        return
      }

      if (!this.detail.hasOwnProperty(key)) {
        console.warn(`La clé "${key}" n'existe pas dans GamefactEventDto.`);
        return;
      }
  
      this.detail[key] = value;
  
      // 🏎️ **Règles automatiques**
      if (key === "period") {
        this.detail.timer = 0; // 🔄 Si la période change, on reset le timer
      }
  
      if (key === "team") {
        // 🔄 Si l'équipe change, on reset les champs liés au joueur
        ["buteur", "player", "transformer", "droper", "penaliter", "shoter", "passeur", "inplayer", "outplayer", "opponent"].forEach(field => {
          this.detail[field] = "";
        });
      }
    }
  }